export default () => {
  return {
    /**
     * If user is a manager then we just bind all clinic clients
     */
    managedClients: [],

    /**
     * Otherwise we have to load clients individually.
     */
    loadedClients: [],

    isLoadingClients: false,

    /**
     * Used for ignoring notifications that are triggered by the user itself after changing the client.
     * For now, it's applying only from the supervisor role as no other role below can change the client info.
     *
     * This should be moved to the separate vuex module (e.g. "triggerNotifications") if there are more places
     * where we need to use vuex for handling trigger notifications.
     */
    clientsTriggerNotificationsToIgnore: [],
  };
};
